

// /* ========================================================
// 日付の成型
// =========================================================*/
// exports.formatDate = function (date, format) {
// 	format = format.replace(/YYYY/, date.getFullYear());

// 	let m = ('00' + (date.getMonth() + 1)).slice(-2);
// 	let d = ('00' + date.getDate()).slice(-2);
// 	format = format.replace(/MM/, m);
// 	format = format.replace(/DD/, d);
// 	// let day = [ "SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT" ][date.getDay()] ;
// 	// format = format.replace(/DAY/, day);
// 	return format;
// }
// exports.formatDate2 = function (date) {
// 	let y = date.getFullYear();
// 	let m = ('00' + (date.getMonth() + 1)).slice(-2);
// 	let d = ('00' + date.getDate()).slice(-2);
// 	return (y + m + d);
// }

const ua = navigator.userAgent;
const device = ((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) ?
	"sp" : "pc";

exports.isPc = function () {
	return (device === "pc") ? true : false;
}


/* ========================================================
要素の高さ揃え
=========================================================*/
exports.setHeightBox = function (NAME) {
	NAME = NAME ? NAME : "js-fix";

	// 高さ揃え
	const elem = document.getElementsByClassName(NAME);
	let h_list = getHeight(elem);
	h_list = Math.max.apply(null, h_list);
	// console.log("設定する高さ：" + h_list);
	if (h_list === 0) return;
	// document.querySelector(".message").innerHTML += "height:" + h_list + "<br>";

	setHeight(elem, h_list);

}
function setHeight(target, h) {
	for (let h_i = 0; h_i < target.length; h_i++) {
		target[h_i].style.height = h + "px";
	}
}
function getHeight(target) {
	let h = [];
	for (let h_n = 0; h_n < target.length; h_n++) {
		h[h_n] = target[h_n].clientHeight;
		// console.log(target[h_n]);
		// console.log(target[h_n].offsetHeight);
	}
	return h;
}
exports.setLoadAllCallback = function (elems, callback) {
	let count = 0;

	for (let i = 0; i < elems.length; i++) {
		let img = new Image();
		img.onload = function () {
			count++;
			if (count === elems.length) {
				callback(elems);
				// console.log("▼全画像読み込み終了");
			}
		}
		img.src = elems[i].src;
	};


	// // console.log(elems.length);
	// for (let i = 0; i < elems.length; ++i) {
	// 	elems[i].addEventListener("load", function () {
	// 		count++;
	// 		// console.log(count + " " + elems.length);
	// 		if (count === elems.length) {
	// 			callback(elems);
	// 			console.log("▼全画像読み込み終了");
	// 		}
	// 	});
	// }
}
